import { useEffect, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { CheckCircle, XCircle, Spinner } from "@phosphor-icons/react";

export default function CheckoutSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refreshUser } = useAuth();
  const [status, setStatus] = useState("polling");
  const [tx, setTx] = useState(null);
  const polled = useRef(0);

  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) {
      setStatus("error");
      return;
    }
    const poll = async () => {
      polled.current += 1;
      if (polled.current > 12) {
        setStatus("timeout");
        return;
      }
      try {
        const { data } = await api.get(`/checkout/status/${sid}`);
        setTx(data);
        if (data.payment_status === "paid") {
          setStatus("paid");
          // Refresh user so the new plan is reflected immediately in the UI
          refreshUser?.();
          return;
        }
        if (data.status === "expired") {
          setStatus("expired");
          return;
        }
      } catch (err) {
        console.error("[CheckoutSuccess] poll failed:", err);
      }
      setTimeout(poll, 2500);
    };
    poll();
  }, []);

  return (
    <Layout>
      <section className="min-h-[70vh] flex items-center justify-center px-4 py-24">
        <div className="max-w-xl text-center">
          {status === "polling" && (
            <>
              <Spinner size={64} weight="duotone" color="#39FF14" className="mx-auto mb-6 animate-spin" />
              <h1 className="as-heading text-4xl text-white mb-3" data-testid="checkout-polling">VERIFICANDO PAGO...</h1>
              <p className="text-as-gray">Por favor espera unos segundos.</p>
            </>
          )}
          {status === "paid" && (
            <>
              <CheckCircle size={80} weight="duotone" color="#39FF14" className="mx-auto mb-6" />
              <h1 className="as-heading text-4xl text-white mb-3" data-testid="checkout-success">
                ¡PAGO <span className="text-as-green">COMPLETADO!</span>
              </h1>
              <p className="text-as-gray mb-6">
                Plan: <b className="text-white">{tx?.metadata?.plan_name}</b><br />
                Monto: <b className="text-as-green">${tx?.amount} USD</b>
              </p>
              <p className="text-as-gray mb-8">
                Recibirás tu programa por email en las próximas 24-48 horas.
              </p>
              <button onClick={() => navigate("/dashboard")} className="as-btn-primary" data-testid="go-dashboard">
                Ir al panel
              </button>
            </>
          )}
          {(status === "timeout" || status === "expired" || status === "error") && (
            <>
              <XCircle size={80} weight="duotone" color="#FF3B30" className="mx-auto mb-6" />
              <h1 className="as-heading text-4xl text-white mb-3">PAGO NO COMPLETADO</h1>
              <p className="text-as-gray mb-8">Intenta de nuevo o contacta a tu coach.</p>
              <button onClick={() => navigate("/planes")} className="as-btn-primary">Volver a planes</button>
            </>
          )}
        </div>
      </section>
    </Layout>
  );
}
